import { gql } from '@apollo/client';

export const UPDATE_TEAM_NAME = gql`
  mutation UpdateTeamName($name: String!, $teamId: String!) {
    updateTeamName(name: $name, teamId: $teamId) {
      emailAddress
      id
      name
    }
  }
`;
